import { asText } from "@/hq/asText";
import React from "react";
import {
  Building2, User, Globe, Users as UsersIcon, FileText,
  PenSquare, ArrowRight, Circle,
} from "lucide-react";
import { Link } from "react-router-dom";

const ICONS = {
  business_created: Building2,
  contact_created: User,
  website_added: Globe,
  lead_created: UsersIcon,
  enquiry_submitted: FileText,
  lead_updated: PenSquare,
};

const LABELS = {
  business_created: "Business created",
  contact_created: "Contact added",
  website_added: "Website linked",
  lead_created: "Lead created",
  enquiry_submitted: "Enquiry submitted",
  lead_updated: "Lead updated",
};

function friendlyTime(iso) {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    const s = Math.floor((Date.now() - d.getTime()) / 1000);
    if (s < 60) return "just now";
    if (s < 3600) return `${Math.floor(s / 60)}m ago`;
    if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
    if (s < 86400 * 7) return `${Math.floor(s / 86400)}d ago`;
    return d.toLocaleDateString(undefined, { day: "numeric", month: "short", year: "numeric" });
  } catch { return iso; }
}

export default function ActivityTimeline({ items = [], compact = false }) {
  if (!items || items.length === 0) {
    return (
      <div className="text-center py-10 text-[#8A8A8A]" data-testid="hq-activity-empty">
        <div className="text-[11px] tracking-[0.28em] uppercase">No activity yet</div>
        <p className="mt-2 text-sm text-[#4A4A4A]">
          Events will appear here as leads and businesses evolve.
        </p>
      </div>
    );
  }
  return (
    <ol className="relative" data-testid="hq-activity-timeline">
      {items.map((a, idx) => {
        const Icon = ICONS[a.event_type] || Circle;
        const label = LABELS[a.event_type] || a.event_type;
        return (
          <li key={a.id || idx} className="relative pl-12 pb-6 last:pb-0" data-testid={`hq-activity-item-${a.event_type}`}>
            {idx !== items.length - 1 && (
              <span aria-hidden className="absolute left-[15px] top-8 bottom-0 w-px bg-[#EAEAEA]" />
            )}
            <span className="absolute left-0 top-0 w-8 h-8 rounded-full bg-[#FFF7EE] border border-[#FCE1C7] grid place-items-center text-[#FF6A00]">
              <Icon size={15} strokeWidth={2.4} />
            </span>
            <div className="flex flex-wrap items-baseline gap-x-3">
              <div className="text-[13px] font-black tracking-[0.06em] uppercase text-[#0A0A0A]">{label}</div>
              <div className="text-[11px] tracking-[0.22em] uppercase text-[#8A8A8A]">{friendlyTime(a.created_at)}</div>
            </div>
            {a.description && !compact && (
              <div className="mt-1 text-[13px] text-[#4A4A4A]">{asText(a.description)}</div>
            )}
            {a.business_id && (
              <Link to={`/hq/businesses/${a.business_id}`}
                    className="mt-1 inline-flex items-center gap-1 text-[11px] tracking-[0.22em] uppercase text-[#FF6A00] hover:text-[#D94C00]">
                View business <ArrowRight size={12} />
              </Link>
            )}
          </li>
        );
      })}
    </ol>
  );
}
